export enum CardClassEnum {
  DASHBOARD = 'dashboads-card',
  RODADA = 'rodadas-card',
  DETALHE = 'detalhes-card',
  CONTATO = 'contato-card'
}
